import { Line3 } from "three";
function anatomyToLine(item, out = new Line3()) {
	if ("joints" in item) {
		out.start.fromArray(item.joints[0].pos);
		out.end.fromArray(item.joints[1].pos);
	} else {
		out.start.fromArray(item.points[0]);
		out.end.fromArray(item.points[1]);
	}
	return out;
}
export { anatomyToLine };

//# sourceMappingURL=index3.js.map